import { matches, returnIfEmpty } from 'components/core/form';
import { compareDesc, isAfter, isBefore, sub, subYears } from 'date-fns';

export const firstLetterIsCharacter = matches(
  /^[A-Za-z][A-Za-z0-9\s]*$/,
  'First name must start with a letter',
);

export const lastLetterIsCharacter = matches(
  /^[A-Za-z][A-Za-z0-9\s]*$/,
  'Last name must start with a letter',
);

export const pronounsLetterIsCharacter = matches(
  /^[A-Za-z][A-Za-z0-9\s]*$/,
  'Pronouns must start with a letter',
);

export const over18 = returnIfEmpty((v: Date) =>
  compareDesc(v, sub(new Date(), { years: 18 })) === 1
    ? null
    : 'Account holders must be over 18',
);

export const under104 = returnIfEmpty((v: Date) =>
  compareDesc(sub(new Date(), { years: 104 }), v) === 1
    ? null
    : 'Account holders must be younger than 104',
);

export const over2 = returnIfEmpty((v: Date) => {
  if (!v) return null;
  const dob = new Date(v);
  const twoYearsAgo = subYears(Date.now(), 2);
  const isOlderThan2 = isBefore(dob, twoYearsAgo);
  if (!isOlderThan2) return 'Child must be at least 2 year old';
  return null;
});

export const over7 = returnIfEmpty((v: Date) => {
  if (!v) return null;
  const dob = new Date(v);
  const sevenYearsAgo = subYears(Date.now(), 7);
  const isOlderThan7 = isBefore(dob, sevenYearsAgo);
  if (!isOlderThan7) return 'Child must be at least 7 years old';
  return null;
});

export const under26 = returnIfEmpty((v: Date) => {
  if (!v) return null;
  const dob = new Date(v);
  const oneYearAgo = subYears(Date.now(), 1);
  const eighteenYearsAgo = subYears(Date.now(), 26);
  const isYoungerThan18 = isAfter(dob, eighteenYearsAgo);
  const isOlderThan1 = isBefore(dob, oneYearAgo);

  return isYoungerThan18 && isOlderThan1 ? null : 'must be under 26';
});

export const over1 = (v: Date) => {
  if (!v) return null;
  const dob = new Date(v);
  const oneYearAgo = subYears(Date.now(), 1);
  const isOlderThan1 = isBefore(dob, oneYearAgo);
  if (!isOlderThan1) return 'Child must be at least 1 year old';
  return null;
};

export const under18 = (v: Date) => {
  if (!v) return null;
  const dob = new Date(v);
  const oneYearAgo = subYears(Date.now(), 1);
  const eighteenYearsAgo = subYears(Date.now(), 18);
  const isYoungerThan18 = isAfter(dob, eighteenYearsAgo);
  const isOlderThan1 = isBefore(dob, oneYearAgo);

  return isYoungerThan18 && isOlderThan1 ? null : 'Child must be under 18';
};

export const heightFeetValidation = (height: number) =>
  height >= 1 && height < 8 ? null : 'Must be between 1 and 8';

export const heightInchesValidation = (height: number) =>
  height >= 0 && height < 12 ? null : 'Must be at least 0 and less than 12';

export const weightValidation = (weight: number) =>
  weight > 8 && weight < 700 ? null : 'Must be between 8 and 700';

export const systolicBpValidation = (systolicBp: number | null) =>
  systolicBp === null || (systolicBp >= 30 && systolicBp <= 220)
    ? null
    : 'Systolic BP must be between 30 and 220';

export const diastolicBpValidation = (diastolicBp: number | null) =>
  diastolicBp === null || (diastolicBp >= 0 && diastolicBp <= 170)
    ? null
    : 'Diastolic BP must be between 0 and 170';

export const heartRateValidation = (heartRate: number | null) =>
  heartRate === null || (heartRate >= 20 && heartRate <= 350)
    ? null
    : 'Heart rate must be between 20 and 350';
